/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Search criteria
 * @export
 * @interface AuditLogSearchRequest
 */
export interface AuditLogSearchRequest {
    /**
     * 
     * @type {string}
     * @memberof AuditLogSearchRequest
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogSearchRequest
     */
    action?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogSearchRequest
     */
    resourceType?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogSearchRequest
     */
    resourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogSearchRequest
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogSearchRequest
     */
    severity?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AuditLogSearchRequest
     */
    success?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof AuditLogSearchRequest
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AuditLogSearchRequest
     */
    endDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof AuditLogSearchRequest
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof AuditLogSearchRequest
     */
    pageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof AuditLogSearchRequest
     */
    sortBy?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogSearchRequest
     */
    sortOrder?: string;
    /**
     * Case-insensitive full-text search across action, user, resource, context, IP, and change payloads.
     * @type {string}
     * @memberof AuditLogSearchRequest
     */
    searchText?: string;
}

/**
 * Check if a given object implements the AuditLogSearchRequest interface.
 */
export function instanceOfAuditLogSearchRequest(value: object): value is AuditLogSearchRequest {
    return true;
}

export function AuditLogSearchRequestFromJSON(json: any): AuditLogSearchRequest {
    return AuditLogSearchRequestFromJSONTyped(json, false);
}

export function AuditLogSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditLogSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'action': json['action'] == null ? undefined : json['action'],
        'resourceType': json['resourceType'] == null ? undefined : json['resourceType'],
        'resourceId': json['resourceId'] == null ? undefined : json['resourceId'],
        'category': json['category'] == null ? undefined : json['category'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'success': json['success'] == null ? undefined : json['success'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'searchText': json['searchText'] == null ? undefined : json['searchText'],
    };
}

export function AuditLogSearchRequestToJSON(json: any): AuditLogSearchRequest {
    return AuditLogSearchRequestToJSONTyped(json, false);
}

export function AuditLogSearchRequestToJSONTyped(value?: AuditLogSearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'action': value['action'],
        'resourceType': value['resourceType'],
        'resourceId': value['resourceId'],
        'category': value['category'],
        'severity': value['severity'],
        'success': value['success'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'page': value['page'],
        'pageSize': value['pageSize'],
        'sortBy': value['sortBy'],
        'sortOrder': value['sortOrder'],
        'searchText': value['searchText'],
    };
}

